import { useDraggable } from '@dnd-kit/core';
import { transparentImageOnImageDropzoneInput } from '@utils/component-framework';
import { useOpgavekompleksetEntry } from '../../../../../state/hook.entry.js';
import { draggable } from './atom.draggable.style.js';
import { TransparentImageOnImageTile } from './atom.tile.js';
import { jsx } from 'react/jsx-runtime';

function DraggableTile(props) {
  const isPlacedInDropzone = useOpgavekompleksetEntry({
    select: entry => Object.values(entry?.data.tasks[props.taskEntryKey]?.details ?? {}).map(transparentImageOnImageDropzoneInput.entry.asTypeSafe).some(dropzone => dropzone?.tileId === props.tile.id)
  });
  const isDisabled = props.context === "drawer" && isPlacedInDropzone;
  const {
    attributes,
    listeners,
    setNodeRef
  } = useDraggable({
    id: `${props.tile.id}-${props.context}`,
    disabled: isDisabled
  });
  if (isDisabled) {
    return /*#__PURE__*/jsx(TransparentImageOnImageTile, {
      ...props,
      state: "placed"
    });
  }
  return /*#__PURE__*/jsx("div", {
    ref: setNodeRef,
    className: draggable,
    "data-is-dragged": props.isDraggingItem,
    ...attributes,
    ...listeners,
    children: /*#__PURE__*/jsx(TransparentImageOnImageTile, {
      ...props,
      state: props.state,
      isDraggable: true
    })
  });
}

export { DraggableTile };
//# sourceMappingURL=atom.draggable.js.map
